import classNames from "classnames";
import React, { FC } from "react";

import { ITestable, testAttr } from "@/browser";
import { Badge } from "@/components/Badge";
import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { Flex, Tooltip } from "@/eworkitComponents";

import "./_nav-item.scss";

export type TNavItemVariant = "icon" | "text" | "mobile" | "nested" | "nested-mobile";

export interface INavItemProps extends ITestable {
  variant: TNavItemVariant;
  text: string;
  icon?: string;
  iconActive?: string;
  badgeText?: string | number;
  active?: boolean;
  className?: string;
  onClick?: () => void;
}

export const NavItem: FC<INavItemProps> = ({
  variant,
  text,
  icon,
  iconActive,
  badgeText,
  active,
  className,
  testName,
  onClick,
}) => {
  const baseClass = "nav-item";
  const classes = classNames(baseClass, className, `--variant-${variant}`, {
    [`--active`]: !!active,
  });

  const renderContent = () => (
    <Flex onClick={onClick} className={classes} direction="column" {...testAttr({ testName }, { sufix: "nav-item" })}>
      <Flex className={`${baseClass}__container`}>
        {variant === "text" && (
          <Text color={active ? "black" : "grey1"} size="lg">
            {text}
          </Text>
        )}
        {variant === "mobile" && (
          <Flex direction="column" grow={1}>
            <Flex padding={["md", "xs"]} align="center" grow={1} innerMargin="md">
              {icon && <Icon icon={icon} size="md" color="grey1" />}
              <Text color="black" size="lg">
                {text}
              </Text>
            </Flex>
          </Flex>
        )}
        {variant === "nested" && (
          <Flex direction="column" grow={1}>
            <Flex padding={["sm", "sm"]} align="center" grow={1} innerMargin="sm">
              {icon && <Icon icon={icon} size="md" color="grey2" />}
              <Text color="black" size="md">
                {text}
              </Text>
            </Flex>
          </Flex>
        )}
        {variant === "nested-mobile" && (
          <Flex direction="column" grow={1}>
            <Flex padding={["sm", "sm"]} align="center" grow={1} innerMargin="md">
              {icon && <Icon icon={icon} size="md" color="grey1" />}
              <Text color="black" size="lg">
                {text}
              </Text>
            </Flex>
          </Flex>
        )}
        {variant === "icon" && (
          <Icon
            icon={active && iconActive ? iconActive : icon!}
            className={`${baseClass}__icon`}
            color={active ? "grey1" : "grey2"}
          />
        )}

        {badgeText && (
          <Badge className={`${baseClass}__badge`} backgroundColor="default">
            <Text size="sm" color="background-card" weight="bold">
              {badgeText}
            </Text>
          </Badge>
        )}
      </Flex>

      {variant !== "mobile" && variant !== "nested" && variant !== "nested-mobile" && (
        <Flex className={`${baseClass}__active-bar-container`} align="center" justify="center">
          <div className={`${baseClass}__active-bar`} />
        </Flex>
      )}
    </Flex>
  );

  return variant === "icon" ? (
    <Tooltip placement="bottom" content={<Text size="sm">{text}</Text>}>
      {renderContent()}
    </Tooltip>
  ) : (
    renderContent()
  );
};
